import useTemplate from "modules/preview/hooks/useTemplate";

export default function useTestedTemplate() {
  const { data } = useTemplate(false);
  return data?.configuration_details?.tested;
}
